export default __webpack_public_path__ + "static/media/profile.753c19a0.png";